module.exports = __webpack_public_path__ + "static/nlive_meeting-be712893eab01ab3906b3e18be7c2457.gif";